import { SelectionSet } from 'aws-amplify/api';
import { Content, Product, UserProduct } from '../amplify/data-resource';
import { GetProgressReport200Response } from '../generated/api';

export type ProgressReport = GetProgressReport200Response;


export interface UserProductData {
  id: string,
  title: string,
  subtitle:string,
  image:string
}

export const userProductWithStruct = [
  'id',
  'product.*',
  'product.modules.*',
  'product.modules.contents.id',
  'product.modules.contents.title',
  'product.modules.contents.subtitle',
  'product.modules.contents.displayOrder'] as const;
export type UserProductWithStruct = SelectionSet<UserProduct, typeof userProductWithStruct>;

export interface ProductInfo {
  id: string,
  purchaseInfo: ProductPurchaseInfo,
  status?:TransactionStatus
}
export interface TransactionStatus {
  found:boolean,
  ongoing?:boolean,
  success?:boolean
  transaction?:{
    id:string,
    paymentLink:string
  }
}

// export const productPurchaseInfo = [
//   'id',
//   'title',
//   'subtitle',
//   'coverImage',
//   'billingDetails.price',
//   'billingDetails.currency'
// ] as const;
// export type ProductPurchaseInfo = SelectionSet<Product, typeof productPurchaseInfo>;


export const productWithStruct = [
  'id',
  'title',
  'subtitle',
  'coverImage',
  'uniqueName',
  'modules.id',
  'modules.title',
  'modules.displayOrder',
  'modules.subtitle',
  'modules.contents.id',
  'modules.contents.title',
  'modules.contents.subtitle',
  'modules.contents.updatedAt',
  'modules.contents.displayOrder'] as const;
export type ProductWithStruct = SelectionSet<Product, typeof productWithStruct>;


export const contentWithNotes = [
  'id',
  'title',
  'subtitle',
  'moduleId',
  'displayOrder',
  'publishedData',
  'dynamicElements.chats.*',
  'dynamicElements.notes.*',] as const;
export type ContentWithNotes = SelectionSet<Content, typeof contentWithNotes>;

// export const userGroupsByProduct = [
//   'group.id',
//   'group.name',
//   'group.owner',
//   // 'group.members.active',
//   'group.members.member.id',
//   'group.members.member.cognitoId',
//   'group.members.member.name',
//   'group.members.member.email',
//   'group.members.member.avatar',
// ] as const;
// export type GroupJourney = SelectionSet<UserGroup, typeof userGroupsByProduct>;

// export type GJMember = {
//   userId:string,
//   sub:string,
//   name:string,
//   avatar:string
// }
// export type GJ = {id:string,name:string,owner:string,members:GJMember[]}

export enum SIGN_IN_STATUS {
  ALREADY_SIGNED_IN = 'ALREADY_SIGNED_IN',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  CONFIRM_EMAIL = 'CONFIRM_EMAIL',
}


export interface TokenUserData {
  sub: string,
  id: string,
  name: string | null,
  avatarUrl: string | undefined,
  email: string
  isLeader: boolean,
  isEditor: boolean
}
export interface ProductPurchaseInfo {
  name: string,
  price: number,
  currency: string,
  coverImage: string,
  subTitle: string,
}




export enum OperationType {
  OPERA_X,
  LOAD_USER_PROFILE,
  LOAD_ALL_PRODUCTS,
  LOAD_USER_PRODUCTS,
  LOAD_PROD_STRUCT,

  OPEN_PRODUCT,
  OPEN_CONTENT,

  LOAD_PRODUCT_STRUCT,
  LOAD_CONTENT_AND_NOTES,
  CREATE_OR_UPDATE_NOTE,
  DELETE_NOTE,
  SIMPLE_PURCHASE,

  LOAD_JOURNEYS_BY_PRODUCT,
  CREATE_JOURNEY,
  UPDATE_JOURNEY_NAME,
  REMOVE_JOURNEY_MEMBER,
  CLOSE_JOURNEY,
  LEAVE_JOURNEY,

  CREATE_INVITE,
  ACCEPT_INVITE,
  LOAD_INVITE,

  LOAD_CHAT_MESSAGES,
  SEND_CHAT_MESSAGE,

  START_PAYMENT,
  CREATE_PAYMENT_TRANSACTION
}

// -------------------
// -------------------
//    CONTENT TYPES
// -------------------
// -------------------

export class EditorJsElement {
  id?: string;
  type?:string;
  data?:EditorJsData;
}
export class EditorJsData{
  level?:number;
  text?:string
  title?:string
}


//NEW CONTENT TYPES

export enum ElementType {
  BLOCKQUOTE="quote",
  HEADING="heading",
  TEXT_LINE="text",
  PARAGRAPH="paragraph",
  YOUTUBE_VIDEO="youtube_video",
  VIDEO="video",
  OTHER_EMBEDDED_VIDEO="other_embed_video",
  BASE64_ENCODED_IMAGE="base64_image",
  PERSONAL_NOTE="note",
  GROUP_CHAT="chat"
}

export class ContentElement {
  id?:string;
  alias?:string; //used for dynamic elements, such as chat/notes
  content:string; //in dynamic elements, this attribute holds the title information
  awsVideoUrl?:string;
  type:ElementType;
  level?:number;
  constructor(type:ElementType, content:string){
      this.content=content;
      this.type=type;
  }
}

/** 
 * UserProfile to be used throughout the application,
 * usually loaded from the authentication token.
 */
export interface UserProfile {
  id:string,
  sub:string,
  name:string,
  email:string,
  avatar:string,
  about:string,
  phone:string,
  status:string,
  groups:string[],
}



